import api from './api';

const trainerTaskService = {
  getTrainerTasks: (startDate, endDate) => {
    return api.get(`/trainer-tasks?startDate=${startDate}&endDate=${endDate}`);
  },
  createTrainerTask: (data) => api.post('/trainer-tasks', data),
  updateTrainerTask: (id, data) => api.put(`/trainer-tasks/${id}`, data),
  deleteTrainerTask: (id) => api.delete(`/trainer-tasks/${id}`)
};

export default trainerTaskService;
